import React from 'react';
import styled from 'styled-components';

import { AxiosPromise } from 'axios';
import DashboardLayout from '../layouts/DashboardLayout';
import { Loader } from '../atoms';
import SearchPanel from '../molecules/SearchPanel';
import ButtonsResultsPanel from '../organisms/Search/ButtonsResultsPanel';
import SearchTable from '../organisms/Search/SearchTable';
import {
  getSearchCategoriesList,
  SearchTypeList,
} from '../api/search';

const SearchPage = () => {
  const [searchValue, setSearchValue] = React.useState<
    SearchTypeList | {}
  >({});
  const [
    actualEndpoint,
    setActualEndpoint,
  ] = React.useState<Promise<AxiosPromise> | null>(null);
  const [searchKey, setSearchKey] = React.useState('');
  const [activeTabName, setActiveTabName] = React.useState(
    'all',
  );

  const [dates, setDates] = React.useState(
    {} as { fromDate: Date; toDate: Date },
  );

  const [isLoading, setIsLoading] = React.useState(false);

  const searchData = value => {
    setIsLoading(true);
    setSearchKey(value);
    getSearchCategoriesList({ search: value }).then(
      response => {
        setIsLoading(false);
        setSearchValue(response.data);
      },
    );
  };

  const setEndpoint = fn => {
    setActualEndpoint(() => fn);
  };

  return (
    <DashboardLayout>
      <PageWrapper>
        <Container>
          <StyledSearchPanel setSearchValue={searchData} />
          <ButtonsResultsPanel
            searchValuesData={searchValue}
            setEndpoint={setEndpoint}
            setActiveTabName={setActiveTabName}
            setDates={setDates}
          />
        </Container>
        <Container>
          { isLoading ?
            <Loader />
            :
            (<>
              {actualEndpoint && (
                <SearchTable
                  searchKey={searchKey}
                  activeTabName={activeTabName}
                  actualEndpoint={actualEndpoint}
                  dates={dates}
                  setDates={setDates}
                />
              )}
            </>)}
        </Container>
      </PageWrapper>
    </DashboardLayout>
  );
};

const PageWrapper = styled.div`
  padding: 24px;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: 840px) {
    padding: 14px;
  }

  @media (max-width: 540px) {
    padding: 10px;
  }
`;

const Container = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  background: var(--defaultBackground);
  width: 100%;
  box-sizing: border-box;
`;

const StyledSearchPanel = styled(SearchPanel)`
  width: 70%;
  height: 50px;
  font-size: 18px;

  @media (max-width: 840px) {
    width: 100%;
  }
`;

export default SearchPage;
